import { render, staticRenderFns } from "./YourBoxes.vue?vue&type=template&id=3ac9f2e0&scoped=true&"
import script from "./YourBoxes.vue?vue&type=script&lang=js&"
export * from "./YourBoxes.vue?vue&type=script&lang=js&"
import style0 from "./YourBoxes.vue?vue&type=style&index=0&id=3ac9f2e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac9f2e0",
  null
  
)

export default component.exports